// Colombia: 32 departamentos + Bogotá D.C. (nivel 1) + municipios (nivel 2).
// El nivel 2 incluye capitales/ciudades principales como seed;
// el catálogo municipal completo (~1,100) se carga desde DANE (Divipola) antes del go-live.
export const geoDataCO = {
    departments: [
        { id: 0, name: "Seleccione Departamento" },
        { id: 1, name: "Amazonas" },
        { id: 2, name: "Antioquia" },
        { id: 3, name: "Arauca" },
        { id: 4, name: "Atlántico" },
        { id: 5, name: "Bogotá D.C." },
        { id: 6, name: "Bolívar" },
        { id: 7, name: "Boyacá" },
        { id: 8, name: "Caldas" },
        { id: 9, name: "Caquetá" },
        { id: 10, name: "Casanare" },
        { id: 11, name: "Cauca" },
        { id: 12, name: "Cesar" },
        { id: 13, name: "Chocó" },
        { id: 14, name: "Córdoba" },
        { id: 15, name: "Cundinamarca" },
        { id: 16, name: "Guainía" },
        { id: 17, name: "Guaviare" },
        { id: 18, name: "Huila" },
        { id: 19, name: "La Guajira" },
        { id: 20, name: "Magdalena" },
        { id: 21, name: "Meta" },
        { id: 22, name: "Nariño" },
        { id: 23, name: "Norte de Santander" },
        { id: 24, name: "Putumayo" },
        { id: 25, name: "Quindío" },
        { id: 26, name: "Risaralda" },
        { id: 27, name: "San Andrés y Providencia" },
        { id: 28, name: "Santander" },
        { id: 29, name: "Sucre" },
        { id: 30, name: "Tolima" },
        { id: 31, name: "Valle del Cauca" },
        { id: 32, name: "Vaupés" },
        { id: 33, name: "Vichada" }
    ],
    municipalities: [
        { provinceId: 0, id: 0, name: "Seleccione Municipio", code: 0 },
        { provinceId: 1, id: 1, name: "Leticia", code: 101 },
        { provinceId: 2, id: 2, name: "Medellín", code: 201 },
        { provinceId: 2, id: 3, name: "Envigado", code: 202 },
        { provinceId: 2, id: 4, name: "Itagüí", code: 203 },
        { provinceId: 2, id: 5, name: "Bello", code: 204 },
        { provinceId: 2, id: 6, name: "Sabaneta", code: 205 },
        { provinceId: 2, id: 7, name: "Rionegro", code: 206 },
        { provinceId: 3, id: 8, name: "Arauca", code: 301 },
        { provinceId: 4, id: 9, name: "Barranquilla", code: 401 },
        { provinceId: 4, id: 10, name: "Soledad", code: 402 },
        { provinceId: 5, id: 11, name: "Bogotá", code: 501 },
        { provinceId: 6, id: 12, name: "Cartagena de Indias", code: 601 },
        { provinceId: 7, id: 13, name: "Tunja", code: 701 },
        { provinceId: 8, id: 14, name: "Manizales", code: 801 },
        { provinceId: 9, id: 15, name: "Florencia", code: 901 },
        { provinceId: 10, id: 16, name: "Yopal", code: 1001 },
        { provinceId: 11, id: 17, name: "Popayán", code: 1101 },
        { provinceId: 12, id: 18, name: "Valledupar", code: 1201 },
        { provinceId: 13, id: 19, name: "Quibdó", code: 1301 },
        { provinceId: 14, id: 20, name: "Montería", code: 1401 },
        { provinceId: 15, id: 21, name: "Soacha", code: 1501 },
        { provinceId: 15, id: 22, name: "Chía", code: 1502 },
        { provinceId: 15, id: 23, name: "Zipaquirá", code: 1503 },
        { provinceId: 15, id: 24, name: "Girardot", code: 1504 },
        { provinceId: 16, id: 25, name: "Inírida", code: 1601 },
        { provinceId: 17, id: 26, name: "San José del Guaviare", code: 1701 },
        { provinceId: 18, id: 27, name: "Neiva", code: 1801 },
        { provinceId: 19, id: 28, name: "Riohacha", code: 1901 },
        { provinceId: 20, id: 29, name: "Santa Marta", code: 2001 },
        { provinceId: 21, id: 30, name: "Villavicencio", code: 2101 },
        { provinceId: 22, id: 31, name: "Pasto", code: 2201 },
        { provinceId: 23, id: 32, name: "Cúcuta", code: 2301 },
        { provinceId: 24, id: 33, name: "Mocoa", code: 2401 },
        { provinceId: 25, id: 34, name: "Armenia", code: 2501 },
        { provinceId: 26, id: 35, name: "Pereira", code: 2601 },
        { provinceId: 27, id: 36, name: "San Andrés", code: 2701 },
        { provinceId: 28, id: 37, name: "Bucaramanga", code: 2801 },
        { provinceId: 28, id: 38, name: "Floridablanca", code: 2802 },
        { provinceId: 28, id: 39, name: "Barrancabermeja", code: 2803 },
        { provinceId: 29, id: 40, name: "Sincelejo", code: 2901 },
        { provinceId: 30, id: 41, name: "Ibagué", code: 3001 },
        { provinceId: 31, id: 42, name: "Cali", code: 3101 },
        { provinceId: 31, id: 43, name: "Palmira", code: 3102 },
        { provinceId: 31, id: 44, name: "Buenaventura", code: 3103 },
        { provinceId: 31, id: 45, name: "Tuluá", code: 3104 },
        { provinceId: 32, id: 46, name: "Mitú", code: 3201 },
        { provinceId: 33, id: 47, name: "Puerto Carreño", code: 3301 }
    ]
};
